import React, { memo } from "react";
import Chip from "@mui/material/Chip";
import { useBasicChip } from "./useBasicChip";

export default memo(function BasicChip({ title, isActive }) {

    const classes = useBasicChip();
    return <Chip label={title} className={`${classes.chip} ${isActive ? classes.chipActive : classes.chipNotActive}`} />;
})
